var _path, _g, _path2, _path3, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntelligentStored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1724 1.88714L6.57666 0.688132C4.90967 0.253221 3.67755 0.950373 3.22941 2.57882L1.71162 8.09419C1.25613 9.74934 1.97106 10.9316 3.63805 11.3665L8.2338 12.5655C9.92766 13.0074 11.1265 12.3245 11.582 10.6693L13.0998 5.15395C13.5479 3.5255 12.8663 2.32906 11.1724 1.88714Z",
    fill: "url(#paint0_linear_9308_7394)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_9308_7394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05798 6.46832C5.13485 6.3727 4.43335 5.59479 4.43335 4.66671C4.43335 3.73863 5.13485 2.96072 6.05799 2.8651L7.52332 2.71333C8.68174 2.59334 9.68948 3.50209 9.68948 4.66672C9.68948 5.83135 8.68174 6.7401 7.52331 6.6201L6.05798 6.46832Z",
    fill: "#FFBC00"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -3.49442,
    y: -0.555818,
    width: 22.7529,
    height: 21.0501
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.16px)",
      clipPath: "url(#bgblur_0_9308_7394_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4.31461,
    d: "M10.9883 3.84863C12.1904 3.84863 13.1584 4.18472 13.8262 4.81738C14.4946 5.45071 14.8516 6.37109 14.8516 7.51562C14.8516 7.64076 14.8519 8.30334 14.8525 9.21582C14.8532 10.129 14.8535 11.2925 14.8535 12.418C14.8535 13.5623 14.4973 14.4836 13.8291 15.1182C13.1614 15.7521 12.1933 16.0898 10.9912 16.0898H4.77344C3.57105 16.0898 2.60335 15.7521 1.93555 15.1182C1.26706 14.4835 0.910157 13.5625 0.910156 12.418V7.51562C0.910156 6.37109 1.267 5.45071 1.93555 4.81738C2.60337 4.1848 3.5712 3.8487 4.77344 3.84863H10.9883Z",
    fill: "#FFBC00",
    fillOpacity: 0.35,
    stroke: "url(#paint1_linear_9308_7394)",
    strokeWidth: 0.179775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 5.26962,
    y: 3.71078,
    width: 15.2248,
    height: 12.4349
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.16px)",
      clipPath: "url(#bgblur_1_9308_7394_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4.31461,
    d: "M15.3627 8.11523C15.7635 8.11609 16.0893 8.43923 16.0902 8.83789V11.0186C16.0902 11.4183 15.7634 11.7412 15.3627 11.7412H11.5697V11.7402C10.6826 11.7553 9.90461 11.151 9.70935 10.29V10.2871C9.68637 10.1721 9.67419 10.0542 9.67419 9.93652C9.67295 8.93212 10.4906 8.11839 11.5013 8.11523H15.3627Z",
    fill: "#FFBC00",
    fillOpacity: 0.35,
    stroke: "url(#paint2_linear_9308_7394)",
    strokeWidth: 0.179775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 8.07901,
    y: 6.49331,
    width: 6.9101,
    height: 6.87007
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.35px)",
      clipPath: "url(#bgblur_2_9308_7394_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_9308_7394)",
    "data-figma-bg-blur-radius": 2.69663
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5341,
    cy: 9.9284,
    rx: 0.758427,
    ry: 0.738462,
    fill: "url(#paint3_linear_9308_7394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5344 9.20752C11.9436 9.20771 12.2746 9.53096 12.2747 9.92822C12.2747 10.3256 11.9437 10.6487 11.5344 10.6489C11.125 10.6489 10.7932 10.3257 10.7932 9.92822C10.7933 9.53084 11.1251 9.20752 11.5344 9.20752Z",
    stroke: "url(#paint4_linear_9308_7394)",
    strokeOpacity: 0.5,
    strokeWidth: 0.0359551
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 1.04605,
    y: 3.8395,
    width: 10.3306,
    height: 6.39326
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.35px)",
      clipPath: "url(#bgblur_3_9308_7394_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_9308_7394)",
    "data-figma-bg-blur-radius": 2.69663
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1484 7.53618H4.26694C3.97636 7.53502 3.74146 7.31027 3.74268 7.03442C3.7439 6.75973 3.9782 6.5373 4.26694 6.53614H8.15085C8.44142 6.53498 8.67877 6.75798 8.68 7.03384C8.68122 7.31027 8.44632 7.53502 8.15574 7.53618H8.15085H8.1484Z",
    fill: "url(#paint5_linear_9308_7394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26709 6.55371H8.15088C8.43244 6.55259 8.66045 6.76914 8.66162 7.03418C8.66265 7.29967 8.43716 7.51738 8.15576 7.51855H4.26709C3.98555 7.51743 3.75908 7.29923 3.76025 7.03418C3.76161 6.77035 3.98746 6.55484 4.26709 6.55371Z",
    stroke: "url(#paint6_linear_9308_7394)",
    strokeOpacity: 0.5,
    strokeWidth: 0.0359551
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7394",
    x: 0.837844,
    y: -0.892869,
    width: 12.4471,
    height: 11.1192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79775,
    result: "effect1_foregroundBlur_9308_7394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7394_clip_path",
    transform: "translate(3.49442 0.555818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 3.84863C12.1904 3.84863 13.1584 4.18472 13.8262 4.81738C14.4946 5.45071 14.8516 6.37109 14.8516 7.51562C14.8516 7.64076 14.8519 8.30334 14.8525 9.21582C14.8532 10.129 14.8535 11.2925 14.8535 12.418C14.8535 13.5623 14.4973 14.4836 13.8291 15.1182C13.1614 15.7521 12.1933 16.0898 10.9912 16.0898H4.77344C3.57105 16.0898 2.60335 15.7521 1.93555 15.1182C1.26706 14.4835 0.910157 13.5625 0.910156 12.418V7.51562C0.910156 6.37109 1.267 5.45071 1.93555 4.81738C2.60337 4.1848 3.5712 3.8487 4.77344 3.84863H10.9883Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7394_clip_path",
    transform: "translate(-5.26962 -3.71078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3627 8.11523C15.7635 8.11609 16.0893 8.43923 16.0902 8.83789V11.0186C16.0902 11.4183 15.7634 11.7412 15.3627 11.7412H11.5697V11.7402C10.6826 11.7553 9.90461 11.151 9.70935 10.29V10.2871C9.68637 10.1721 9.67419 10.0542 9.67419 9.93652C9.67295 8.93212 10.4906 8.11839 11.5013 8.11523H15.3627Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_9308_7394",
    x: 8.07901,
    y: 6.49331,
    width: 6.9101,
    height: 6.87007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.898876,
    dy: 0.898876
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.898876
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.737255 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7394",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_9308_7394_clip_path",
    transform: "translate(-8.07901 -6.49331)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5341,
    cy: 9.9284,
    rx: 0.758427,
    ry: 0.738462
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_9308_7394",
    x: 1.04605,
    y: 3.8395,
    width: 10.3306,
    height: 6.39326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.898876,
    dy: 0.898876
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.898876
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.737255 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7394",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_9308_7394_clip_path",
    transform: "translate(-1.04605 -3.8395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1484 7.53618H4.26694C3.97636 7.53502 3.74146 7.31027 3.74268 7.03442C3.7439 6.75973 3.9782 6.5373 4.26694 6.53614H8.15085C8.44142 6.53498 8.67877 6.75798 8.68 7.03384C8.68122 7.31027 8.44632 7.53502 8.15574 7.53618H8.15085H8.1484Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7394",
    x1: 13.1035,
    y1: 2.39094,
    x2: 0.29909,
    y2: 6.37486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7394",
    x1: 3.19101,
    y1: 5.34366,
    x2: 12.9421,
    y2: 16.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7394",
    x1: 10.7567,
    y1: 8.60656,
    x2: 13.1187,
    y2: 12.9605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7394",
    x1: 12.1849,
    y1: 9.45664,
    x2: 10.4954,
    y2: 9.51322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9308_7394",
    x1: 10.939,
    y1: 9.68538,
    x2: 12.2271,
    y2: 9.69268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9308_7394",
    x1: 8.32995,
    y1: 6.71672,
    x2: 2.96344,
    y2: 7.58057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9308_7394",
    x1: 4.27453,
    y1: 6.8716,
    x2: 8.46402,
    y2: 6.98578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentStored);
export default __webpack_public_path__ + "static/media/intelligentStored.b6951b5f91433e4c521577be483e4e7a.svg";
export { ForwardRef as ReactComponent };